import script from "./DaftarPembelianBarang.vue?vue&type=script&setup=true&lang=js"
export * from "./DaftarPembelianBarang.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__